//Generated File 
export default class DashboardConstants{
	static readonly Param_AvgValue = `AvgValue`;
	static readonly Param_Category = `Category`;
	static readonly Param_Color = `color`;
	static readonly Param_ColumnCategory = `ColumnCategory`;
	static readonly Param_ColumnLabel = `ColumnLabel`;
	static readonly Param_ColumnValue = `ColumnValue`;
	static readonly Param_ColumnsWidths = `ColumnsWidths`;
	static readonly Param_FinalColumnsOrder = `FinalColumnsOrder`;
	static readonly Param_FromDate = `FromDate`;
	static readonly Param_FromDateTime = `FromDateTime`;
	static readonly Param_FromTime = `FromTime`;
	static readonly Param_GaugeBands = `GaugeBands`;
	static readonly Param_GuageUnit = `GuageUnit`;
	static readonly Param_HIDDEN_COLUMNS = `HiddenColumns_CSV`;
	static readonly Param_HTMLArabicTemplate = `HTMLArabicTemplate`;
	static readonly Param_HTMLEnglishTemplate = `HTMLEnglishTemplate`;
	static readonly Param_HTMLOpenInIFrame = `HTMLOpenInIFrame`;
	static readonly Param_INHTML = `INHTML`;
	static readonly Param_Label = `Label`;
	static readonly Param_Link = `Link`;
	static readonly Param_LinkToID = `LinkToID`;
	static readonly Param_LinkToType = `LinkToType`;
	static readonly Param_MatrixPointText = `MatrixPointText`;
	static readonly Param_OpenLinkInNewTab = `openLinkInNewTab`;
	static readonly Param_ParentResourceID = `ParentResourceID`;
	static readonly Param_PieLabel = `PieLabel`;
	static readonly Param_PieValue = `PieValue`;
	static readonly Param_PivotColumns = `PivotColumns`;
	static readonly Param_PivotOpenByDefault = `PivotOpenByDefault`;
	static readonly Param_PivotRowGroupColumns = `RowGroupColumns`;
	static readonly Param_PivotValueColumns = `ValueColumns`;
	static readonly Param_PlotBands = `PlotBands`;
	static readonly Param_PointName = `PointName`;
	static readonly Param_RangeFrom = `RangeFrom`;
	static readonly Param_RangeTo = `RangeTo`;
	static readonly Param_ResourceID = `ResourceID`;
	static readonly Param_ResourceName = `ResourceName `;
	static readonly Param_Stack = `Stack`;
	static readonly Param_Style = `Style`;
	static readonly Param_TableArabicHeader = `TableArabicHeader`;
	static readonly Param_TableBorderWidth = `TableBorderWidth`;
	static readonly Param_TableEnglishHeader = `TableEnglishHeader`;
	static readonly Param_Title = `Title`;
	static readonly Param_ToDate = `ToDate`;
	static readonly Param_ToDateTime = `ToDateTime`;
	static readonly Param_ToTime = `ToTime`;
	static readonly Param_ToolTipInfo = `ToolTipInfo`;
	static readonly Param_URL = `URL`;
	static readonly Param_Value = `Value`;
	static readonly Param_XCategory = `xCategory`;
	static readonly Param_YCategory = `yCategory`;
	static readonly Param_maxTime = `maxTime`;
	static readonly Param_minTime = `minTime`;
}
